(function () {
  'use strict';

  var overlay = null;
  var closeTimer = null;
  var CLOSE_DURATION = 420;

  function getDetails() {
    var el = document.querySelector('header-drawer');
    return el ? el.querySelector('#Details-menu-drawer-container') : null;
  }

  function openOverlay() {
    if (overlay) overlay.classList.add('swnav-overlay--visible');
    document.body.classList.add('swnav-locked');
  }

  function closeOverlay() {
    if (overlay) overlay.classList.remove('swnav-overlay--visible');
    document.body.classList.remove('swnav-locked');
  }

  // Animated close: add menu-closing class first, then remove [open] after
  // the CSS clip-path transition completes. This keeps [open] on details
  // during the animation so the transition fires cleanly.
  function closeDrawer() {
    var details = getDetails();
    if (!details || !details.open) return;
    if (details.classList.contains('menu-closing')) return;

    details.classList.add('menu-closing');
    closeOverlay();

    if (closeTimer) clearTimeout(closeTimer);
    closeTimer = setTimeout(function () {
      details.classList.remove('menu-closing', 'menu-opening');
      details.removeAttribute('open');
      closeTimer = null;
    }, CLOSE_DURATION);
  }

  // Shopify's link.current / link.child_active can miss pages whose URLs don't
  // exactly match the nav entry. Re-apply active classes from the live URL.
  function applyActiveStates() {
    var currentPath = window.location.pathname;
    var headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    headerDrawer.querySelectorAll('.swnav-drawer__details').forEach(function (subDet) {
      var trigger = subDet.querySelector(':scope > .swnav-drawer__trigger');
      var childLinks = subDet.querySelectorAll('.swnav-drawer__child-link');
      var hasActive = false;

      childLinks.forEach(function (link) {
        try {
          var linkPath = new URL(link.href, window.location.origin).pathname;
          if (linkPath === currentPath) {
            link.classList.add('swnav-drawer__child-link--active');
            hasActive = true;
          }
        } catch (e) {}
      });

      if (hasActive && trigger) {
        trigger.classList.add('swnav-drawer__trigger--active');
      }
    });

    headerDrawer.querySelectorAll('.swnav-drawer__link').forEach(function (link) {
      try {
        var linkPath = new URL(link.href, window.location.origin).pathname;
        if (linkPath === currentPath) {
          link.classList.add('swnav-drawer__link--active');
        }
      } catch (e) {}
    });
  }

  applyActiveStates();

  function init() {
    var headerDrawer = document.querySelector('header-drawer');
    if (!headerDrawer) return;

    var details = headerDrawer.querySelector('#Details-menu-drawer-container');
    if (!details) return;

    var summary = details.querySelector(':scope > summary');

    overlay = document.createElement('div');
    overlay.className = 'swnav-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);

    // Intercept summary click when open — prevent native toggle and animate close
    if (summary) {
      summary.addEventListener('click', function (e) {
        if (details.open) {
          e.preventDefault();
          closeDrawer();
        }
      });
    }

    // Toggle fires when we manually remove [open] after close animation,
    // and when Dawn opens the drawer natively (our preventDefault only fires on close)
    details.addEventListener('toggle', function () {
      if (details.open) {
        openOverlay();
      }
    });

    // Sub-accordions: fully JS-driven so the UA's details hiding never fires.
    // Always preventDefault — open/close state lives in .sub-open class only.
    var SUB_DURATION = 320;
    headerDrawer.querySelectorAll('.swnav-drawer__details').forEach(function (subDet) {
      var subSummary = subDet.querySelector(':scope > summary');
      if (!subSummary) return;

      // When the accordion opens natively, add sub-is-open on the next frame
      // so the browser sees the "before" color and can transition to the new one.
      subDet.addEventListener('toggle', function () {
        if (subDet.open) {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              subSummary.classList.add('sub-is-open');
            });
          });
        }
      });

      subSummary.addEventListener('click', function (e) {
        if (!subDet.open) return;
        e.preventDefault();
        // Remove sub-is-open immediately so the trigger starts fading back to red
        // in sync with the close animation.
        subSummary.classList.remove('sub-is-open');
        subDet.classList.add('sub-closing');
        setTimeout(function () {
          subDet.classList.remove('sub-closing');
          subDet.removeAttribute('open');
        }, SUB_DURATION + 60);
      });
    });

    overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && details.open) {
        closeDrawer();
      }
    });

    headerDrawer.addEventListener('click', function (e) {
      if (e.target.closest('.swnav-drawer__close-btn')) {
        closeDrawer();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
